// extracted by mini-css-extract-plugin
export default {"footerBg":"L-z","footerTopLinks":"M-z","footerFeedback":"N-z","footerSocial":"O-z","footerLegalLinks":"P-z","footerIconCards":"Q-z","footerBotCopy":"R-z"};